import MetConstantes from "../datosVars/metConstants";
import ColorContraste from "../colores/colorContraste"
import { Escala, Escalas } from "./escala";
import {
    EscalaRojoAzul,
    EscalaRojoAzulContraste,
    EscalaAzules,
    EscalaAzulesContraste,
    EscalaVerdeRojo,
    EscalaVerdeRojoContrastes,
    EscalaCelesteGris,
    EscalaCelesteGrisContraste
} from "../../res/colors";

/**
 * Dato el id de una variable, retorna una escala de valores de largo 11.
 *
 * @param {numeric} idVar
 */
function getEscalaValores(idVar) {
    if (MetConstantes.idsTemperaturas.includes(idVar)) {
        return [-5, 0, 5, 10, 15, 20, 25, 30, 32, 35, 40];
    } else if (MetConstantes.idsHumRelativa.includes(idVar)) {
        return [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    } else if (MetConstantes.idsPrecip.includes(idVar)) {
        return [0, 0.1, 1, 4, 7, 13, 20, 30, 40, 50, 60];
    } else if (MetConstantes.idsPresAtm.includes(idVar)) {
        return [970, 980, 985, 990, 995, 1000, 1010, 1020, 1030, 1040, 1045];
    } else if (MetConstantes.idsIntViento.includes(idVar)) {
        return [0, 10, 20, 35, 50, 65, 75, 90, 100, 120, 140];
    } else if (MetConstantes.idsVisibilidad.includes(idVar)) {
        return [0, 0.05, 0.1, 0.5, 1, 2, 4, 6, 10, 15, 20];
    } else if (MetConstantes.idsNubosidad.includes(idVar)) {
        return [0, 1, 2, 3, 4, 5, 6, 7];
    } else
        return []
}

function getEscalasColores(idVar) {
    if (MetConstantes.idsTemperaturas.includes(idVar)) {
        return EscalaRojoAzul;
    } else if (MetConstantes.idsHumRelativa.includes(idVar)) {
        return EscalaRojoAzul;
    } else if (MetConstantes.idsPrecip.includes(idVar)) {
        return EscalaAzules;
    } else if (MetConstantes.idsPresAtm.includes(idVar)) {
        return EscalaRojoAzul;
    } else if (MetConstantes.idsIntViento.includes(idVar)) {
        return EscalaVerdeRojo;
    } else if (MetConstantes.idsVisibilidad.includes(idVar)) {
        return EscalaVerdeRojo.slice().reverse();
    } else if (MetConstantes.idsNubosidad.includes(idVar)) {
        return EscalaCelesteGris;
    } else
        return []
}

function getEscalasColoresContrastes(idVar) {
    if (MetConstantes.idsTemperaturas.includes(idVar)) {
        return EscalaRojoAzulContraste;
    } else if (MetConstantes.idsHumRelativa.includes(idVar)) {
        return EscalaRojoAzulContraste;
    } else if (MetConstantes.idsPrecip.includes(idVar)) {
        return EscalaAzulesContraste;
    } else if (MetConstantes.idsPresAtm.includes(idVar)) {
        return EscalaRojoAzulContraste;
    } else if (MetConstantes.idsIntViento.includes(idVar)) {
        return EscalaVerdeRojoContrastes;
    } else if (MetConstantes.idsVisibilidad.includes(idVar)) {
        return EscalaVerdeRojoContrastes.slice().reverse()  ;
    } else if (MetConstantes.idsNubosidad.includes(idVar)) {
        return EscalaCelesteGrisContraste;
    } else
        return []
}

function getEscalaVar(idVar) {
    return new Escala(
        getEscalaValores(idVar),
        getEscalasColores(idVar),
        getEscalasColoresContrastes(idVar)
    );
}

function getEscalasVars(idsVars) {
    let res = new Escalas();
    idsVars.forEach(id => {
        res.add(id,getEscalaVar(id));
    });
    return res;
}

function getColConTiempoPres(dato){
    let col = "#ffffff";
    let con = "#000000"
    if (dato >= 10 && dato <= 12){
        col= "#bdbdbd"
    } else if ((dato === 13) || (dato >= 17 && dato <= 19) || (dato >= 50 && dato <= 63) || (dato >= 80 && dato <= 86) || (dato === 90)){
        col= "#fff176"
    } else if (dato >= 40 && dato <= 49){
        col= "#757575"
        con="#ffffff"
    } else if ((dato >= 64 && dato <= 69) || (dato >= 87 && dato <= 89) || (dato >= 91 && dato <= 96)){
        col= "#ffb74d"
    } else if (dato >= 97 && dato <= 99){
        col= "#ef5350"
        con="#ffffff"
    } else {
        col= "#4caf50"
    }
    return new ColorContraste(col,con);
}

export {
    getEscalaValores,
    getEscalasColores,
    getEscalasColoresContrastes,
    getEscalaVar,
    getEscalasVars,
    getColConTiempoPres
};
